import { render } from "./IconMap.vue.js?vue&type=template&id=7b4a7f26!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconMap.vue?vue&type=template&id=7b4a7f26"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__